import React, { useState } from "react";
import { Done, FileCopyOutlined } from "@mui/icons-material";

type CodeSnippetProps = {
  inline?: boolean;
  rawText?: string;
  children?: React.ReactNode;
};

export const CodeSnippet = ({ children, inline, rawText }: CodeSnippetProps) => {
  const [copied, setCopied] = useState(false);
  const copyText = rawText ?? children.toString();

  return (
    <div
      className={`code-snippet ${
        inline ? "d-inline-block flex-grow code-snippet--inline" : "d-block"
      }`}
    >
      <div className="code-snippet--inner">
        <span className="code-snippet--content">
          <span className="text-t1 text-font-mono" style={{ whiteSpace: "pre-wrap" }}>
            {children}
          </span>
        </span>
        <span className="code-snippet--action-container">
          {copyText && (
            <span
              className="code-snippet--action"
              onClick={() => {
                navigator.clipboard?.writeText(copyText);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              }}
            >
              {copied ? (
                <>
                  <span className="snippet-copied">
                    <Done />{" "}
                  </span>
                  Copied
                </>
              ) : (
                <>
                  <span className="snippet-copy">
                    <FileCopyOutlined />{" "}
                  </span>
                  Copy
                </>
              )}
            </span>
          )}
        </span>
      </div>
    </div>
  );
};
